/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetChargebacksInput
 */
export interface GetChargebacksInput {
    /**
     * UTC Unix timestamp
     * @type {string}
     * @memberof GetChargebacksInput
     */
    updateDate: string;
}

/**
 * Check if a given object implements the GetChargebacksInput interface.
 */
export function instanceOfGetChargebacksInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "updateDate" in value;

    return isInstance;
}

export function GetChargebacksInputFromJSON(json: any): GetChargebacksInput {
    return GetChargebacksInputFromJSONTyped(json, false);
}

export function GetChargebacksInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChargebacksInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updateDate': json['updateDate'],
    };
}

export function GetChargebacksInputToJSON(value?: GetChargebacksInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updateDate': value.updateDate,
    };
}

